/* Maple Wheels — minimal theme JS */
(function () {
  'use strict';

  /* reveal on scroll */
  var reveals = document.querySelectorAll('.rev');
  if (reveals.length) {
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
        });
      }, { threshold: 0.14 });
      reveals.forEach(function (el) { io.observe(el); });
    } else {
      reveals.forEach(function (el) { el.classList.add('in'); });
    }
  }

  /* mobile nav */
  var burger = document.querySelector('[data-burger]');
  var mnav = document.querySelector('[data-mobile-nav]');
  if (burger && mnav) {
    burger.addEventListener('click', function () {
      var open = mnav.classList.toggle('open');
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  /* mobile submenu accordions */
  document.querySelectorAll('[data-msub]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var open = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', open ? 'false' : 'true');
      var panel = btn.nextElementSibling;
      if (panel) panel.classList.toggle('open', !open);
    });
  });

  /* keyboard escape closes an open desktop dropdown */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var active = document.activeElement;
    if (active && active.closest && active.closest('.has-sub')) active.blur();
  });

  /* collection filter tabs (client-side, homepage grid) */
  var tabs = document.querySelectorAll('[data-filter]');
  if (tabs.length) {
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var f = tab.getAttribute('data-filter');
        tabs.forEach(function (t) { t.setAttribute('aria-selected', t === tab ? 'true' : 'false'); });
        document.querySelectorAll('[data-card]').forEach(function (card) {
          var tags = (card.getAttribute('data-tags') || '').toLowerCase();
          card.hidden = !(f === 'all' || tags.indexOf(f) !== -1);
        });
      });
    });
  }

  /* product gallery */
  var gallery = document.querySelector('[data-gallery]');
  if (gallery) {
    var mainImg = gallery.querySelector('[data-gallery-main] img');
    gallery.querySelectorAll('[data-thumb]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!mainImg) return;
        mainImg.src = btn.getAttribute('data-src');
        mainImg.srcset = btn.getAttribute('data-srcset') || '';
        mainImg.alt = btn.getAttribute('data-alt') || '';
        gallery.querySelectorAll('[data-thumb]').forEach(function (b) {
          b.setAttribute('aria-current', b === btn ? 'true' : 'false');
        });
      });
    });
  }

  /* variant selection */
  var form = document.querySelector('[data-variant-form]');
  if (form) {
    var data = document.querySelector('[data-variant-json]');
    var variants = data ? JSON.parse(data.textContent) : [];
    var idField = form.querySelector('[name="id"]');
    var priceEl = document.querySelector('[data-price]');
    var stockEl = document.querySelector('[data-stock]');
    var btn = form.querySelector('[data-add]');
    var money = form.getAttribute('data-money') || '${{amount}}';

    function fmt(cents) {
      var v = (cents / 100).toFixed(2);
      return money.replace(/\{\{\s*amount\s*\}\}/, v).replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100));
    }

    function current() {
      var chosen = [];
      form.querySelectorAll('[data-opt]').forEach(function (group) {
        var sel = group.querySelector('input:checked');
        chosen.push(sel ? sel.value : null);
      });
      return variants.filter(function (v) {
        return chosen.every(function (c, i) { return c === null || v.options[i] === c; });
      })[0];
    }

    function sync() {
      var v = current();
      if (!v) return;
      if (idField) idField.value = v.id;
            /* variant-linked image */
      if (v.media) {
        var gal = document.querySelector('[data-gallery]');
        var gimg = gal && gal.querySelector('[data-gallery-main] img');
        if (gimg && gimg.getAttribute('src') !== v.media.src) {
          gimg.src = v.media.src;
          gimg.srcset = v.media.srcset || '';
          gimg.alt = v.media.alt || '';
        }
        if (gal) {
          gal.querySelectorAll('[data-thumb]').forEach(function (b) {
            b.setAttribute('aria-current',
              b.getAttribute('data-media-id') === String(v.media.id) ? 'true' : 'false');
          });
        }
      }
      if (priceEl) {
        priceEl.innerHTML = fmt(v.price) + ' <span class="cur">' + (form.getAttribute('data-currency') || '') + '</span>';
      }
      if (stockEl) {
        stockEl.textContent = v.available ? 'In stock' : 'Sold out';
        stockEl.classList.toggle('in', v.available);
      }
      if (btn) {
        btn.disabled = !v.available;
        btn.textContent = v.available ? 'Add to cart' : 'Sold out';
      }
      if (history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        history.replaceState({}, '', url.toString());
      }
    }

    form.querySelectorAll('[data-opt] input').forEach(function (i) {
      i.addEventListener('change', sync);
    });
    sync();
  }

  /* quantity steppers */
  document.querySelectorAll('[data-qty]').forEach(function (wrap) {
    var input = wrap.querySelector('input');
    wrap.querySelectorAll('button').forEach(function (b) {
      b.addEventListener('click', function () {
        var step = parseInt(b.getAttribute('data-step'), 10);
        var next = Math.max(1, (parseInt(input.value, 10) || 1) + step);
        input.value = next;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });

  /* cart line quantity auto-submit */
  document.querySelectorAll('[data-cart-qty]').forEach(function (input) {
    input.addEventListener('change', function () {
      input.form.submit();
    });
  });
})();


/* APPEND to assets/theme.js — back link uses real browser history.
   Falls through to the link's href when there is no same-site page to return to
   (direct landing, new tab, link shared from Instagram, search result). */
(function () {
  document.querySelectorAll('[data-back]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var ref = document.referrer;
      if (!ref || history.length < 2) return;            // nothing to go back to
      var sameSite = false;
      try { sameSite = new URL(ref).origin === location.origin; } catch (err) {}
      if (!sameSite) return;                             // came from off-site
      e.preventDefault();
      history.back();
    });
  });
})();


